import Vue from 'vue'
import VueRouter from 'vue-router'
import routerList from '@/data/routes.js'
import store from '@/store'


Vue.use(VueRouter)

const routes = routerList;
const router = new VueRouter({
  //mode: 'history',
  //base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  if ((to.name !== 'Login' && to.name !== 'Cadastre-se') && !router.app.$store.getters.isLoggedIn){
    router.app.$setLsFrom(to.fullPath);
    next({ name: 'Login' })
  }else{
    document.title = to.meta.title;
    next()
  } 
});

export default router
